import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'highlight',
  standalone: true,
})
export class HighlightPipe implements PipeTransform {
  transform(text: string, search: string): string {
    if (!search) {
      return text;
    }

    const re = new RegExp(`(.{0,20})(${search})(.{0,20})`, 'gi');
    const match = re.exec(text);

    if (match) {
      return `${match[1]}<span class="highlight">${match[2]}</span>${match[3]}`;
    }

    return text;
  }
}
